import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Modal from 'components/Common/MUIModal/Modal';
import ModalHeader from 'components/Common/MUIModal/ModalHeader';
import ModalBody from 'components/Common/MUIModal/ModalBody';
import ModalActions from 'components/Common/MUIModal/ModalActions';
import { ProductKind } from 'types/ProductPageV2/Products';

import styles from './ProductSizeModal.module.scss';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  type: ProductKind;
  content: React.ReactNode;
  renderAddBasket: () => JSX.Element;
};

export default function ProductSizeModal({
  isOpen,
  closeModal,
  type,
  content,
  renderAddBasket,
}: Props): JSX.Element | null {
  const { t } = useTranslation(['productPage']);

  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      className={styles.container}
      classes={{ innerContainer: styles.modalWrapper }}
    >
      <ModalHeader
        onClose={closeModal}
        className={styles.header}
        classes={{ closeElement: { closeButton: styles.closeButton } }}
      >
        <span className={styles.title}>
          {t(type === 1 ? 'LABEL_CHOOSE_SIZE' : 'LABEL_CHOOSE_SIZE_CUP')}
        </span>
      </ModalHeader>
      <ModalBody
        className={classNames(
          styles.content,
          type !== 1 && styles.appendPadding,
          type === 1 && styles.appendScrollGradient
        )}
      >
        {content}
      </ModalBody>
      <ModalActions>{renderAddBasket()}</ModalActions>
    </Modal>
  );
}
